import { ChangeEventHandler, FocusEventHandler, forwardRef, FunctionComponent } from "react";

import CloseIcon from "@/assets/icons/close.svg?url";
import { classNames } from "@/utils/classNames";

interface InputProps {
	value: string;
	handleChange: ChangeEventHandler<HTMLInputElement>;
	placeholder?: string;
	handleBlur?: FocusEventHandler;
	name: string;
	onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
	icon?: JSX.Element;
	image?: JSX.Element;
	disabled?: boolean;
	isError?: boolean;
	handleReset?: () => void;
	testId?: string;
	className?: string;
	classNameInput?: string;
}

export const CampaignSearchField = forwardRef<HTMLInputElement, InputProps>(
	(
		{
			value,
			handleChange,
			placeholder,
			handleBlur,
			name,
			onClick,
			icon,
			image,
			disabled,
			isError,
			handleReset,
			testId,
			className,
			classNameInput,
		},
		ref
	) => {
		return (
			<>
				<div
					className="relative flex items-center flex-row"
					data-test={testId}
					onClick={(e: React.MouseEvent<HTMLDivElement>) => {
						onClick?.(e);
					}}
				>
					{!!image && (
						<div
							className={classNames(
								"inline-flex w-4 mr-1 items-center flex-row text-gray-500 peer-focus:text-brand-light",
								className
							)}
						>
							{image}
						</div>
					)}
					<input
						ref={ref}
						autoComplete="off"
						className={classNames(
							"pr-8 peer",
							icon ? "pl-16" : "",
							image ? "pl-0 pr-2" : "",
							isError && "border-status-error",
							classNameInput
						)}
						data-test="search-input"
						disabled={disabled}
						name={name}
						placeholder={placeholder}
						tabIndex={0}
						type="text"
						value={value}
						onBlur={handleBlur}
						onChange={handleChange}
					/>

					{handleReset && !!value && (
						<div className="absolute right-[14px] top-[50%] translate-y-[-50%] transform text-gray-500 peer-focus:text-brand-light cursor-pointer hover:text-brand-light">
							<img
								alt="closeicon"
								id="closeIcon"
								src={CloseIcon}
								width={12}
								onClick={(e) => {
									e.stopPropagation();
									handleReset();
								}}
							/>
						</div>
					)}
				</div>
			</>
		);
	}
);
CampaignSearchField.displayName = "CampaignSearchField";
